import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { HttpErrorHandler, HandleError } from '../http-error-handler.service';
import { Activity, ActivityList, TaskList } from '../../models/activity';
import { ReassignProblemPayload } from 'src/app/state-management';

@Injectable()
export class ActivityService {
  activitiesUrl = 'api/activities';
  private handleError: HandleError;

  httpOptions = {
    headers: new HttpHeaders({
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache'
    })
  };

  constructor(
    private httpClient: HttpClient,
    httpErrorHandler: HttpErrorHandler
  ) {
    this.handleError = httpErrorHandler.createHandleError('ActivitiesService');
  }

  getActivities(): Observable<ActivityList[]> {
    return this.httpClient.get<ActivityList[]>(this.activitiesUrl, this.httpOptions);
    /* .pipe(
      catchError(this.handleError('getActivities', []))
    ); */
  }

  getTask(activityNo: string): Observable<TaskList> {
    return this.httpClient.get<TaskList>(this.activitiesUrl + '/getTask/' + activityNo, this.httpOptions);
    /* .pipe(
      catchError(this.handleError('getActivities', []))
    ); */
  }

  getTasks(): Observable<TaskList[]> {
    return this.httpClient.get<TaskList[]>(this.activitiesUrl, this.httpOptions);
    /* .pipe(
      catchError(this.handleError('getActivities', []))
    ); */
  }

  getActivityById(problemNo: string): Observable<ActivityList[]> {
    return this.httpClient.get<ActivityList[]>(this.activitiesUrl + '/' + problemNo, this.httpOptions).pipe(
      catchError(this.handleError('getActivityById', []))
    );
  }

  getActivityByActivityNo(activityNo: string): Observable<ActivityList[]> {
    return this.httpClient.get<ActivityList[]>(this.activitiesUrl + '/activity?activityNo=' + activityNo, this.httpOptions).pipe(
      catchError(this.handleError('getActivityById', []))
    );
  }

  addActivities(activity: Activity): Observable<ActivityList> {
    return this.httpClient.post<ActivityList>(this.activitiesUrl, activity)
      .pipe(
        catchError(this.handleError('addActivities', null))
      );
  }

  updateActivity(activityObj: { activityId: number, activity: Activity }): Observable<ActivityList[]> {
    return this.httpClient.post<ActivityList[]>(this.activitiesUrl + '/' + activityObj.activityId, activityObj.activity, this.httpOptions);
  }

  cancelActivity(problemNo: string, activityId: number): Observable<ActivityList[]> {
    return this.httpClient.post<ActivityList[]>(`${this.activitiesUrl}/cancelActivity/${problemNo}/${activityId}`, this.httpOptions);
  }

  addReassignActivity(reassign: ReassignProblemPayload): Observable<ActivityList> {
    return this.httpClient.post<ActivityList>(this.activitiesUrl + '/ReassignProblem', reassign);
  }

  // addReassignGroupActivity(reassignGroup: ReassignGroup): Observable<ActivityList> {
  //   return this.httpClient.post<ActivityList>(this.activitiesUrl + '/ReassignGroup', reassignGroup);
  // }
}
